import { useQuery } from "@tanstack/react-query"

import { getFoodOrder } from "@/lib/food/foodPaymentService"
import { NO_REFETCH_OPTIONS } from "@/utils/query/constants"

export function useFoodOrder(foodOrderId: string | undefined) {
  return useQuery({
    queryKey: ['food-order', foodOrderId],
    queryFn: foodOrderId ? ({signal}) => getFoodOrder({foodOrderId, signal}) : skipToken,
    throwOnError: false,
    placeholderData: keepPreviousData,
    ...NO_REFETCH_OPTIONS
  })
}
